<template>
    <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid">
        <div class="wrapper">
            <div class="list-articles list-articles__product-types container">
                <!-- Breadcrumb -->
                <div class="row">
                    <div class="col">
                        <ol class="breadcrumb">
                            <li><a href="#">Cash Market</a></li>
                            <li class="active">Dispositivos Móviles</li>
                        </ol>
                    </div>
                </div>

                <!-- Section Title -->
                <div class="row list-articles__title devices">
                    <div class="col-md-12 ">
                        <h1>Dispositivos Móviles</h1>
                    </div>
                </div> 

                <div class="row list-articles__container">
                    <!-- Side Menu -->
                    <div class="col-md-2">
                        <span class="filter-header">Filtrar por</span>
                        <div class="row filter offer--cards__bg">
                            <!--  -->
                            <div class="filter__item brands">
                                <span class="filter__title" data-for="marcas">Marcas</span>
                                <div class="filter__content" data-name="marcas" data-type="checkboxes">
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="motorola" id="motorola"/>
                                        <label for="motorola" class="">Motorola</label>
                                    </div>
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="samsung" id="samsung"/>
                                        <label for="samsung" class="">Samsung</label>
                                    </div>
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="huawei" id="huawei"/>
                                        <label for="huawei" class="">Huawei</label>
                                    </div>
                                </div>
                                <a href="#">Ver más</a>
                            </div>
                            
                            <div class="filter__item system">
                                <span class="filter__title" data-for="marcas">Sistema Operativo</span>
                                <div class="filter__content" data-name="marcas" data-type="checkboxes">
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="motorola" id="motorola"/>
                                        <label for="motorola" class="">Android</label>
                                    </div>
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="samsung" id="samsung"/>
                                        <label for="samsung" class="">IOS</label>
                                    </div>
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="huawei" id="huawei"/>
                                        <label for="huawei" class="">Windows</label>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="filter__item devices-type">
                                <span class="filter__title" data-for="marcas">Tipo de Dispositivo</span>
                                <div class="filter__content" data-name="marcas" data-type="checkboxes">
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="motorola" id="motorola"/>
                                        <label for="motorola" class="">Celular</label>
                                    </div>
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="samsung" id="samsung"/>
                                        <label for="samsung" class="">TV</label>
                                    </div>
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="huawei" id="huawei"/>
                                        <label for="huawei" class="">Tablet</label>
                                    </div>
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="huawei" id="huawei"/>
                                        <label for="huawei" class="">Audífonos</label>
                                    </div>
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="huawei" id="huawei"/>
                                        <label for="huawei" class="">Laptop</label>
                                    </div>
                                    <div class="filter--checkbox">
                                        <input type="checkbox" name="huawei" id="huawei"/>
                                        <label for="huawei" class="">Desktop</label>
                                    </div>
                                </div>
                                <a href="#">Ver más</a>
                            </div>

                        </div>
                    </div>
                    
                    <!-- Product Types List -->
                    <div class="col-md-10">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- Showing Results -->
                                <div class="row showing-results">
                                    <div class="col-md-8">
                                        Mostrando 1-40 de 1000 resultados para Dispositivos Móviles
                                    </div>
                                    <div class="col-md-4">
                                        <!-- Sort By -->
                                        <div class="sort-by__container">
                                            <form>
                                                <div class="form-group sort-by__content">
                                                    <label class="sort-by__title">Ordenar por</label>
                                                    <div class="sort-by__options content-input">
                                                        <input type="hidden" name="sort-by" value="best-selling">
                                                        <select class="form-control sort-by__select" id="sort-by">
                                                            <option value="price-ascending">Precio - Bajo a Alto</option>
                                                            <option value="price-descending">Precio - Alto a Bajo</option>
                                                            <option value="best-selling">Más vendidos</option>
                                                            <option value="title-ascending">Alfabéticos, A-Z</option>
                                                            <option value="title-descending">Alfabéticos, Z-A</option>
                                                            <option value="created-ascending">Lo más Nuevo</option>
                                                            <option value="created-descending">Menos Nuevo</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <div class="row offer__content devices--list">
                                    <!-- Product #1 -->
                                    <div class="col-md-4  offer--cards offer--cards__bg">
                                        <div class="devices--list__image">
                                            <img src="/images/offes-news-img/samsung-gold.png">
                                        </div>

                                        <div class="devices--list__content">
                                            <h4>Samsung Galaxy J5</h4>
                                            <div class="devices--list__price">
                                                <sub class="sign-price">RD$</sub> 
                                                <span class="currency-price">10,200</span> 
                                                <sub class="cent-price">.00</sub>
                                            </div>
                                            <div class="classification--stars">
                                                <img src="/images/offes-news-img/stars-orange.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Product #2 -->
                                    <a href="#!/product-detail-devices">
                                        <div class="col-md-4  offer--cards offer--cards__bg">
                                            <div class="devices--list__image">
                                                <img src="/images/offes-news-img/cell-samsung.png">
                                            </div>

                                            <div class="devices--list__content">
                                                <h4>Samsung Galaxy S9 Plus</h4>
                                                <div class="devices--list__price">
                                                    <sub class="sign-price">RD$</sub> 
                                                    <span class="currency-price">22,500</span> 
                                                    <sub class="cent-price">.00</sub>
                                                </div>
                                                <div class="classification--stars">
                                                    <img src="/images/offes-news-img/stars-3.png" />
                                                </div>
                                            </div>
                                        </div>
                                    </a>

                                    <!-- Product #3 -->
                                    <div class="col-md-4  offer--cards offer--cards__bg">
                                        <div class="devices--list__image">
                                            <img src="/images/offes-news-img/iphone.png">
                                        </div>

                                        <div class="devices--list__content">
                                            <h4>Apple iPhone 6s 16GB</h4>
                                            <div class="devices--list__price">
                                                <sub class="sign-price">RD$</sub> 
                                                <span class="currency-price">15,198</span> 
                                                <sub class="cent-price">.00</sub>
                                            </div>
                                            <div class="classification--stars">
                                                <img src="/images/offes-news-img/stars-4.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Product #4 -->
                                    <div class="col-md-4  offer--cards offer--cards__bg">
                                        <div class="devices--list__image">
                                            <img src="/images/offes-news-img/samsung-gold.png">
                                        </div>

                                        <div class="devices--list__content">
                                            <h4>Samsung Galaxy J5</h4>
                                            <div class="devices--list__price">
                                                <sub class="sign-price">RD$</sub> 
                                                <span class="currency-price">10,200</span> 
                                                <sub class="cent-price">.00</sub>
                                            </div>
                                            <div class="classification--stars">
                                                <img src="/images/offes-news-img/stars-orange.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Product #5 -->
                                    <div class="col-md-4  offer--cards offer--cards__bg">
                                        <div class="devices--list__image">
                                            <img src="/images/offes-news-img/cell-samsung.png">
                                        </div>

                                        <div class="devices--list__content">
                                            <h4>Samsung Galaxy S9 Plus</h4>
                                            <div class="devices--list__price">
                                                <sub class="sign-price">RD$</sub> 
                                                <span class="currency-price">22,500</span> 
                                                <sub class="cent-price">.00</sub>
                                            </div>
                                            <div class="classification--stars">
                                                <img src="/images/offes-news-img/stars-3.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Product #6 -->
                                    <div class="col-md-4  offer--cards offer--cards__bg">
                                        <div class="devices--list__image">
                                            <img src="/images/offes-news-img/iphone.png">
                                        </div>

                                        <div class="devices--list__content">
                                            <h4>Apple iPhone 6s 16GB</h4>
                                            <div class="devices--list__price">
                                                <sub class="sign-price">RD$</sub> 
                                                <span class="currency-price">15,198</span> 
                                                <sub class="cent-price">.00</sub>
                                            </div>
                                            <div class="classification--stars">
                                                <img src="/images/offes-news-img/stars-1.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Product #7 -->
                                    <div class="col-md-4  offer--cards offer--cards__bg">
                                        <div class="devices--list__image">
                                            <img src="/images/offes-news-img/samsung-gold.png">
                                        </div>

                                        <div class="devices--list__content">
                                            <h4>Samsung Galaxy J5</h4>
                                            <div class="devices--list__price">
                                                <sub class="sign-price">RD$</sub> 
                                                <span class="currency-price">10,200</span> 
                                                <sub class="cent-price">.00</sub>
                                            </div>
                                            <div class="classification--stars">
                                                <img src="/images/offes-news-img/stars-gray.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Product #8 -->
                                    <div class="col-md-4  offer--cards offer--cards__bg">
                                        <div class="devices--list__image">
                                            <img src="/images/offes-news-img/cell-samsung.png">
                                        </div>

                                        <div class="devices--list__content">
                                            <h4>Samsung Galaxy S9 Plus</h4>
                                            <div class="devices--list__price">
                                                <sub class="sign-price">RD$</sub> 
                                                <span class="currency-price">22,500</span> 
                                                <sub class="cent-price">.00</sub>
                                            </div>
                                            <div class="classification--stars">
                                                <img src="/images/offes-news-img/stars-3.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Product #9 -->
                                    <div class="col-md-4  offer--cards offer--cards__bg">
                                        <div class="devices--list__image">
                                            <img src="/images/offes-news-img/iphone.png">
                                        </div>

                                        <div class="devices--list__content">
                                            <h4>Apple iPhone 6s 16GB</h4>
                                            <div class="devices--list__price">
                                                <sub class="sign-price">RD$</sub> 
                                                <span class="currency-price">15,198</span> 
                                                <sub class="cent-price">.00</sub>
                                            </div>
                                            <div class="classification--stars">
                                                <img src="/images/offes-news-img/stars-1.png" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import vue from 'vue'
import router from 'vue-router'

vue.use(router)

export default {
    name:'ProductDetailDevices',
    referTo: '/product-detail-devices'
}
</script>

<style lang="css" scoped>
img {
    max-width: 100%;
}
h1 {
    font-size: 26px;
}
a {
    color:#213F99;
}
a:hover {
    text-decoration: underline;
    color:#213F99;
}
/* Breadcrum */
.breadcrumb {
    margin-bottom: 0px;
    text-transform: capitalize;
}
.breadcrumb li.active {
    color: #000000;
}
.breadcrumb li a {
    color: #898989;
}
/* Showing Results */
.showing-results {
    margin: 20px 0px;
}
/* Sort By */
.sort-by__content {
    margin: 0;
}
.sort-by__title,
.sort-by__options {
    margin: 0;
}
.sort-by__title {
    float: left;
}
.sort-by__options {
    float: right;
}
.sort-by__select {
    padding: 0px 30px 0 10px;
    border: 0;
    background-color: transparent;
    box-shadow: none;
    color: #000;
}
/* Classification Star */
.stars--item {
    text-align: left;
    max-width:150px;
    width: 100%;
    height: 38px;
}
.list-articles__title {
    text-align:center;
    margin: 0px 0px 20px 0px;
}
.filter-header {
    display: block;
    margin: 18px 0px;
    font-size: 17px;
    color: #898989;
}
.filter__item { /* remove */
    margin:15px 0;
}
/* Devices List */
.devices--list a {
    color: #333333;
}
.devices--list .devices--list__image {
    width: 250px;
    height: 250px;
}
/* Offer Style */
.offer--title h1 {
    font-weight: bold;
}
.offer--title a {
    display: block;
    margin: 30px 0px 20px;
    text-align: right;
}
.offer--title .col-lg-2,
.offer--title .col-lg-10 {
    padding-left:0px;
    padding-right:0px;
}
.offer--cards__bg {
    background: #fff;
    border: 1px solid #ccc;
    padding: 15px 20px;
}
.offer--cards {
    max-width: 305px;
    min-height: 400px;
    text-align: left;
    margin: 0 10px 20px;
}
.offer--cards h3 {
    margin-top: 20px;
}
.offer--cards h4 {
    margin-bottom: 5px;
}
.offer--cards p {
    font-size: 18px;
    margin-top: 30px;
    color:#42494B;
}
.offer--cards a {
    display: block;
    margin-top: 15px;
    margin-bottom: 15px;
}
.sign-price,
.currency-price {
    vertical-align: middle;
}
.currency-price {
    font-size: 24px;
}
.cent-price {
    vertical-align: sub;
    margin-left: -5px;
}
</style>


// WEBPACK FOOTER //
// devices-list.vue?7ef87cb0